export const PHONE = "+916301262393";
export const PHONE_DISPLAY = "+91 6301262393";
export const EMAIL = "smiletondental1@gmail.com";
export const ADDRESS_LINE = "2nd Floor, Shivam Tejas Building, Above Ratnadeep Supermarket, Sainikpuri 1st Main Rd";
export const ADDRESS_FULL =
  "2nd Floor, Shivam Tejas Building, Sainikpuri 1st Main Rd, above Ratnadeep Supermarket, Vayupuri, Sainikpuri, Secunderabad, Telangana 500094";
export const WHATSAPP_URL = `https://wa.me/916301262393?text=${encodeURIComponent("Hi Smileton Dental, I'd like to know more about an appointment.")}`;
export const MAPS_DIR_URL = `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent("Smileton Dental, Shivam Tejas Building, Sainikpuri, Secunderabad 500094")}`;
export const MAP_EMBED = `https://www.google.com/maps?q=${encodeURIComponent("Smileton Dental, Shivam Tejas Building, Sainikpuri, Secunderabad")}&output=embed`;
export const DAY_NAMES = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

export const scrollToBooking = () => {
  document.getElementById("book")?.scrollIntoView({ behavior: "smooth", block: "start" });
};
